import { useLangStore } from "../store/lang";
import type { Language } from "../i18n/strings";

const OPTIONS: Array<{ code: Language; label: string }> = [
  { code: "en", label: "EN" },
  { code: "si", label: "සි" },
  { code: "ta", label: "த" },
];

export function LanguagePicker() {
  const { lang, setLang } = useLangStore();
  return (
    <div className="lang-switch">
      {OPTIONS.map((o) => (
        <button
          key={o.code}
          type="button"
          onClick={() => setLang(o.code)}
          className={lang === o.code ? "active" : ""}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
